import type * as React from 'react';
import { EmptyState, KitBarChart, KitDonutChart, KitLineChart } from '@redhand/ui';
import { demoOrderStates, demoWeekSales } from '../demo-data.js';
import { PageIntro, StateSection } from '../ui-helpers.js';

export function ChartsPage(): React.JSX.Element {
  return (
    <div>
      <PageIntro
        title="Grafy (bar · line · donut)"
        lead="Tenké wrappery nad Recharts. Barvy jdou z tématu (--rh-chart-1…5) — přepni téma v topbaru a grafy se přebarví. Heatmapa je v0.2."
      />
      <StateSection title="Sloupcový — tržby po dnech (dvě řady)">
        <div className="rh-card">
          <KitBarChart
            ariaLabel="Tržby po dnech, toto a minulé období"
            data={demoWeekSales}
            xKey="day"
            series={[
              { key: 'current', label: 'Toto období' },
              { key: 'previous', label: 'Minulé období' },
            ]}
          />
        </div>
      </StateSection>
      <StateSection title="Čárový — vývoj">
        <div className="rh-card">
          <KitLineChart
            ariaLabel="Vývoj tržeb po dnech"
            data={demoWeekSales}
            xKey="day"
            series={[{ key: 'current', label: 'Tržby' }]}
          />
        </div>
      </StateSection>
      <StateSection title="Donut — stavy objednávek se středovou hodnotou">
        <div className="rh-card">
          <KitDonutChart
            ariaLabel="Rozložení stavů objednávek"
            data={demoOrderStates}
            centerValue="436"
            centerLabel="objednávek"
          />
        </div>
      </StateSection>
      <StateSection title="Prázdný stav grafu" description="Bez dat se nekreslí prázdná osa — ukazuje se EmptyState.">
        <div className="rh-card">
          <EmptyState title="Zatím žádná data za zvolené období" description="Vyber delší období, nebo počkej na první objednávky." />
        </div>
      </StateSection>
    </div>
  );
}
